var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Quill } from 'react-quill';
var BaseImageFormat = Quill.import('formats/image');
var imageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style',
    'relativeWidth',
];
var ImageFormat = /** @class */ (function (_super) {
    __extends(ImageFormat, _super);
    function ImageFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageFormat.formats = function (domNode) {
        var _a, _b, _c;
        var width = domNode.width || domNode.offsetWidth || domNode.clientWidth;
        var richTextWidth = (_c = (_b = (_a = domNode === null || domNode === void 0 ? void 0 : domNode.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode) === null || _c === void 0 ? void 0 : _c.offsetWidth;
        var height = domNode.height || domNode.offsetHeight || domNode.clientHeight;
        var existingHeight = domNode.getAttribute('height');
        var existingWidth = domNode.getAttribute('width');
        domNode.onload = function () {
            if (height === 0)
                height = domNode.height;
            if (width === 0)
                width = domNode.width;
        };
        if (!existingHeight || height.toString() !== existingHeight) {
            domNode.setAttribute('height', height);
        }
        if (!existingWidth || width.toString() !== existingWidth) {
            domNode.setAttribute('width', width);
            domNode.setAttribute('relativeWidth', richTextWidth);
        }
        return imageFormatAttributesList.reduce(function (formats, attribute) {
            if (attribute === 'height' || attribute === 'width') {
                // when adding an Image for react native to render height should be there
                if (!isNaN(height) && height > 0) {
                    formats['height'] = height;
                }
                // when adding an Image for react native to render width should be there
                if (!isNaN(width) && width > 0) {
                    formats['width'] = width;
                    formats['relativeWidth'] = richTextWidth;
                }
            }
            else if (domNode.hasAttribute(attribute)) {
                // react native does not support float, so we had to manually remove float and use block and margin for alignment
                if (attribute === 'style') {
                    var styles = domNode.getAttribute('style');
                    var newStyles = styles;
                    if (styles.includes('float: right;')) {
                        newStyles = newStyles.replace('float: right;', 'margin-left: auto !important;');
                    }
                    if (styles.includes('float: left;')) {
                        newStyles = newStyles.replace('float: left;', 'margin-right: auto !important;');
                    }
                    newStyles = newStyles.replace('display: inline;', 'display: block;');
                    formats['style'] = newStyles;
                }
                else {
                    formats[attribute] = domNode.getAttribute(attribute);
                }
            }
            return formats;
        }, {});
    };
    ImageFormat.prototype.format = function (name, value) {
        if (imageFormatAttributesList.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            }
            else {
                this.domNode.removeAttribute(name);
            }
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    return ImageFormat;
}(BaseImageFormat));
export default ImageFormat;
